import * as Yup from 'yup'
import { Form } from '@unform/web'
import { Background, Container, InputWrapper, Modal, WrapperPaymentForm } from './styles'
import { AiOutlineClose } from 'react-icons/ai'
import { toast } from 'react-toastify'
import Input from 'components/Input'
import { useCallback, useRef, useState } from 'react'
import { learningApi } from 'services/api'
import type { FormHandles } from '@unform/core/typings/types'
import valid from 'card-validator'
import moment from 'moment'

interface ModalProps {
  setModalOpen: (value: boolean) => void
  charge: any
  order: string
}

function removeSpecialChars(str: string) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9 ]/g, '')
}

function getValidationError(err: Yup.ValidationError) {
  const validationErrors = {}

  for (const error of err.inner) {
    validationErrors[error.path] = error.message
  }

  return validationErrors
}

const FormSchema = Yup.object().shape({
  name: Yup.string().required('Informe o nome escrito no cartão'),
  number: Yup.string()
    .test('test-number', 'Cartão de crédito inválido', (value) => valid.number(value).isValid)
    .required('Informe o número do cartão'),
  code: Yup.string().required('Informe o código de segurança'),
  date: Yup.string()
    .test('test-number', 'Cartão expirado', (value) => {
      const cardDate = value.split('/')
      const thisMonth = moment().month() + 1
      const thisYear = moment().year().toString().slice(-2)
      if (Number(cardDate[1]) < Number(thisYear)) return false
      if (Number(cardDate[0]) > 12) return false
      if (Number(cardDate[0]) < thisMonth && Number(cardDate[1]) === Number(thisYear)) return false

      return true
    })
    .required('Informe a validade do cartão'),
})

export const ModalCreditCard: React.FC<ModalProps> = ({ setModalOpen, charge, order }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const token = localStorage.getItem('token')

  const formRef = useRef<FormHandles>()

  const handleSubmit = useCallback(
    async (data: any) => {
      setLoading(true)

      try {
        formRef.current?.setErrors({})

        await FormSchema.validate(data, {
          abortEarly: false,
        })

        data.name = removeSpecialChars(data.name)
        data.date = data.date.replace('/', '')

        const url = charge?._id
          ? `/order/update-payment-token/${order}/${charge?._id}`
          : `/order/update-payment-token/${order}`

        await learningApi.patch(url, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        toast.success('Dados alterados com sucesso')
        formRef.current?.reset()

        setLoading(false)
      } catch (error) {
        console.log(error)

        if (error instanceof Yup.ValidationError) {
          const errors = getValidationError(error)
          formRef.current?.setErrors(errors)
          return
        }

        return toast.error('Algo deu errado, tente novamente mais tarde')
      } finally {
        setLoading(false)
        setModalOpen(false)
      }
    },
    [order, charge?._id, token, setModalOpen]
  )

  return (
    <Background>
      <Modal>
        <Container>
          <div className="CloseModal">
            <>
              <h2>Atualizar dados do cartão</h2>
              <AiOutlineClose
                className="closeModalIcon"
                cursor="pointer"
                onClick={() => {
                  setModalOpen(false)
                }}
              />
            </>
          </div>
          <WrapperPaymentForm>
            <Form ref={formRef} onSubmit={handleSubmit} autoComplete="false">
              <Input name="name" label="Nome" placeholder="NOME DO TITULAR" />
              <Input name="number" label="Número" placeholder="0000 0000 0000 0000" isCreditCard />
              <InputWrapper>
                <div>
                  <Input
                    name="date"
                    label="MM/AA"
                    placeholder="Validade (MM/AA)"
                    isDateCreditCard
                  />
                </div>
                <div>
                  <Input name="code" label="CVV" placeholder="1234" isCvv />
                </div>
              </InputWrapper>
              <button className="filter" type="submit" disabled={loading}>
                Alterar cartão
              </button>
            </Form>
          </WrapperPaymentForm>
        </Container>
      </Modal>
    </Background>
  )
}
